import React from 'react';
import { StarIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Sarah M.',
    content: 'Joshua did an amazing job on my house and gutters! Professional, punctual, and affordable. Highly recommend!',
    rating: 5
  }, {
    name: 'Jennifer T.',
    content: 'Josh exceeded my expectations! My roof looks brand new and he included a complimentary gutter clean out with my roof wash, great service and attention to detail!',
    rating: 5
  }, {
    name: 'David L.',
    content: 'Fast, easy, and affordable! My house and driveway have never looked better, I Definitely recommend if your in the Charlotte area.',
    rating: 5
  }];
  const renderStars = rating => {
    return Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} size={20} className={index < rating ? 'text-green-600 fill-green-600' : 'text-gray-300'} data-id="element-221" />);
  };
  return <section id="testimonials" className="py-16 bg-gray-100" data-id="element-222">
      <div className="container mx-auto px-4" data-id="element-223">
        <div className="text-center mb-12" data-id="element-224">
          <p className="text-green-700 font-semibold mb-2" data-id="element-225">Our Reviews</p>
          
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-226">
            See What Our Customers Are Saying
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-227">
            We take pride in delivering top-quality service and ensuring
            customer satisfaction. See what our happy clients have to say about
            their experience with Professor Pressure Washing LLC!
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-228">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md" data-id="element-229">
              <div className="flex mb-6" data-id="element-230">{renderStars(testimonial.rating)}</div>
              <p className="text-gray-700 mb-8 leading-relaxed" data-id="element-231">
                {testimonial.content}
              </p>
              <p className="font-bold text-gray-900 text-lg" data-id="element-232">
                {testimonial.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};